import React, { useState } from "react"
import { MdOutlineWhatsapp } from "react-icons/md"
import { RiInstagramLine, RiMessengerLine } from "react-icons/ri"
import Modal from '../index'
import Input from '../../Form/Input'
import FormGroup from "../../Form/FormGroup"
import Button from "../../Form/Button"
import Select from '../../Form/Select'
import FormGroupInline from '../../Form/FormGroupInline'
import { getUsersBySelectedTeams, getValidUserIdsByTeams } from '../../../utils/utils'

const ModalNewInbox = ({ teams = [], users = [], onSubmit = () => { }, closeModal = () => { } }) => {
    const [inbox, setInbox] = useState({})

    const handleChangeValue = (name, value) => {
        setInbox(previousValue => ({
            ...previousValue,
            [name]: value,
            ...(name === "teams" ? { users: getValidUserIdsByTeams(previousValue.users, value, users, teams, [], previousValue.teams) } : {}),
        }))
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    const handleSave = (e) => {
        e.preventDefault()
        onSubmit(inbox)
    }

    const getInboxPlatformLabel = () => {
        if (inbox?.platform === "messenger") return "Messenger"
        if (inbox?.platform === "direct") return "Instagram Direct"
        return "WhatsApp"
    }

    const getInboxPlatformIcon = () => {
        if (inbox?.platform === "messenger") return <RiMessengerLine style={{ color: "#0084ff" }} />
        if (inbox?.platform === "direct") return <RiInstagramLine style={{ color: "#e4405f" }} />
        return <MdOutlineWhatsapp style={{ color: "#25d366" }} />
    }

    return (
        <Modal
            icon={getInboxPlatformIcon()}
            title={`Cadastro de nova caixa de entrada do ${getInboxPlatformLabel()}`}
            description={"Preencha os campos abaixo e clique em salvar"}
            closeModal={closeModal}
        >
            <form onSubmit={handleSave}>
                <FormGroup labelText="Nome">
                    <Input type="text" placeholder="Nome da caixa de entrada" value={inbox?.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                </FormGroup>
                {/* <FormGroup labelText="Sincronizar Histórico de Conversas">
                    <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={listoptions || []} selected={inbox?.sync_full_history ?? ""} onChange={(value) => handleChangeValue("sync_full_history", value)} multiple={false} />
                </FormGroup>
                <FormGroup labelText="Ignorar Grupos">
                    <Select name="Selecione uma opção..." placeholder="Pesquise uma opção" options={listoptions || []} selected={inbox?.groups_ignore ?? ""} onChange={(value) => handleChangeValue("groups_ignore", value)} multiple={false} />
                </FormGroup> */}
                <FormGroup labelText="Equipes">
                    <Select name="Equipes" placeholder="Pesquise uma opção" options={teams || []} selected={inbox?.teams ?? ""} onChange={(value) => handleChangeValue("teams", value)} multiple={true} />
                </FormGroup>
                <FormGroup labelText="Usuários">
                    <Select name="Usuários" placeholder="Pesquise uma opção" options={getUsersBySelectedTeams(inbox?.teams, users, teams)} selected={inbox?.users ?? ""} onChange={(value) => handleChangeValue("users", value)} multiple={true} />
                </FormGroup>
                <FormGroupInline>
                    <Button variant='primary' type="submit">Salvar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalNewInbox
